const config = require('./' + process.env.REACT_APP_PROJECT_NAME + '-editview-config');
export default config;
